import { ref, Ref, computed } from '@vue/composition-api';
import {
  RecorderOptions,
  RecorderState,
  RecorderStatus
} from '@issue-detail/components/IssueDrawer/Model/recorder';

export const useRecorder = () => {
  const recorderState: Ref<RecorderState> = ref({
    status: 4,
    countdown: 0,
    remain: 0,
    enableMic: true,
    enableCam: true
  });

  const recorderOptions: Ref<Partial<RecorderOptions>> = ref({});

  const setRecorderState = (state: Partial<RecorderState>) => {
    recorderState.value = {
      ...recorderState.value,
      ...state
    };
  };

  const setRecordOptions = (option: Partial<RecorderOptions>) => {
    recorderOptions.value = {
      ...recorderOptions.value,
      ...option
    };
  };

  const isRecording = computed(() =>
    [
      RecorderStatus.COUNTDOWN,
      RecorderStatus.PAUSED,
      RecorderStatus.RUNNING
    ].includes(recorderState.value.status)
  );

  const isRecordFromIssueDesc = computed(
    () => recorderOptions.value.from === 'issueDesc'
  )

  const isIssueDescRecording = computed(
    () => isRecordFromIssueDesc.value && isRecording.value
  )

  return {
    recorderState,
    isRecording,
    recorderOptions,
    isIssueDescRecording,
    setRecorderState,
    setRecordOptions
  };
};

export type useRecorder = ReturnType<typeof useRecorder>;
